import type { StateCreator } from "zustand";

export interface EnvironmentUrlSliceState {
  environmentUrl: string | undefined;
}

interface EnvironmentUrlSliceActions {
  setEnvironmentUrl: (
    nextEnvironmentUrl:
      | EnvironmentUrlSliceState["environmentUrl"]
      | ((
          currentEnvironmentUrl: EnvironmentUrlSliceState["environmentUrl"]
        ) => EnvironmentUrlSliceState["environmentUrl"])
  ) => void;
}

export type EnvironmentUrlSlice = EnvironmentUrlSliceState & EnvironmentUrlSliceActions;

export const createEnvironmentUrlSlice: StateCreator<
  EnvironmentUrlSlice,
  [["zustand/devtools", never]],
  [],
  EnvironmentUrlSlice
> = (set) => ({
  environmentUrl: undefined,
  setEnvironmentUrl: (nextEnvironmentUrl) =>
    set((state) => ({
      environmentUrl:
        typeof nextEnvironmentUrl === "function"
          ? nextEnvironmentUrl(state.environmentUrl)
          : nextEnvironmentUrl,
    })),
});
